module.exports = __webpack_public_path__ + "static/media/2-1.28530b94.mp3";